import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { EventBusService } from '../../../../services/event-bus.service';

/**
 * Publish validation dialog
 */
@Component({
  selector: 'app-publish-validation-dialog',
  templateUrl: './app-publish-validation-dialog.component.html',
  styleUrls: ['./app-publish-validation-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppPublishValidationDialogComponent extends DestroyBase implements OnInit {
  /**
   * Translation key for the title
   */
  public translationKeyTitle = '';

  /**
   * Invalid fields
   */
  public InvalidFields: string[] = [];

  /**
   * Visible?
   */
  public isDialogVisible = false;

  /**
   * Constructor
   * @param translate TranslateService
   * @param eventBus EventBusService
   */
  constructor(private translate: TranslateService, private eventBus: EventBusService) {
    super();
  }

  /**
   * Cancel
   */
  cancel() {
    this.InvalidFields = [];
    this.isDialogVisible = false;
    this.translationKeyTitle = '';
  }

  /**
   * Initializes the component
   */
  public ngOnInit(): void {
    this.subscriptions.add(this.eventBus.subscribeEvent('openPublishNavigationPopup', (valuationEvent, publishOrRepublish) => {
      if (!valuationEvent.ValuationDate) {
        this.InvalidFields.push('publishValidationDialog.valuationDate');
      }
      if (valuationEvent.ValuationStatusId === 0) {
        this.InvalidFields.push('publishValidationDialog.valuationStatus');
      }
      if (!valuationEvent.ParentId) {
        if (valuationEvent.niy === 0) {
          this.InvalidFields.push('publishValidationDialog.niy');
        }
        if (valuationEvent.nry === 0) {
          this.InvalidFields.push('publishValidationDialog.nry');
        }
        if (valuationEvent.ney === 0) {
          this.InvalidFields.push('publishValidationDialog.ney');
        }
      }
      const titleKey = publishOrRepublish === 'publishPortfolio' ? 'titlePublish' : 'titleRepublish';
      this.translationKeyTitle = this.translate.instant(`publishValidationDialog.${titleKey}`);
      this.isDialogVisible = true;
    }));
  }
}
